import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const MissionQuotationPage_QuotationInfo_Fragment = graphql(`
  fragment MissionQuotationPage_QuotationInfo_Fragment on QuotationInfo {
    _id
    header {
      _id
      paymentMethodId
      paymentTermId
      validityPeriodId
      interventionDate
      modalities
      note
    }
    quotationId
    stateId
    workflowId
  }
`);

export type MissionQuotationPage_QuotationInfo = ResultOf<
  typeof MissionQuotationPage_QuotationInfo_Fragment
>;
